const bound = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'object') {
    return value.days_ago === '' || value.days_ago === undefined
      ? null
      : `${value.days_ago} days ago`;
  }
  return String(value);
};

const range = (from, to, unit) => {
  const suffix = unit === 'local' ? ' (local)' : unit === 'usd' ? ' $' : '';
  if (from && to) return `${from}–${to}${suffix}`;
  if (from) return `from ${from}${suffix}`;
  if (to) return `up to ${to}${suffix}`;
  return null;
};

export const describeCondition = (condition, attribute) => {
  if (!attribute) return null;

  const label = attribute.label;
  const value = condition.value;

  switch (attribute.type) {
    case 'boolean':
      return `${label}: ${value ? 'yes' : 'no'}`;

    case 'enum': {
      const list = Array.isArray(value) ? value : [value];
      return list.length ? `${label}: ${list.join(', ')}` : null;
    }

    case 'date': {
      const text = range(bound(value?.from), bound(value?.to));
      return text ? `${label}: ${text}` : null;
    }

    case 'integer': {
      const ranges = (value?.ranges || [])
        .map((r) => range(r.from, r.to))
        .filter(Boolean);
      if (!ranges.length) return null;

      const window = condition.window ? ` (last ${condition.window} days)` : '';
      return `${label}${window}: ${ranges.join(' or ')}`;
    }

    case 'money': {
      const text = range(value?.from, value?.to, condition.unit);
      return text ? `${label}: ${text}` : null;
    }

    default: {
      const list = Array.isArray(value) ? value.join(', ') : value;
      return list ? `${label}: ${list}` : null;
    }
  }
};

export const describeConditions = (conditions = [], byId = {}) =>
  conditions.map((c) => describeCondition(c, byId[c.attribute])).filter(Boolean);
